import axios from 'axios'

export default {
  list (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/integrator')
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  delete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/integrator/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  created (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/integrator/${id}`)
        .then(({ data }) => {
          context.commit('LIST_ADD', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  updated (context, opts) {
    // if this is the logged in integrator, refresh the whole account
    if (opts === context.state.loggedIn.id) {
      context.dispatch('get')
    }
    // if it's in the list, go fetch its new details
    if (context.state.current.id === opts || context.state.list.find((i) => i.id === opts) !== undefined) {
      axios
        .get(`/api/integrator/${opts}`)
        .then(({ data }) => {
          if (data.id) {
            context.commit('LIST_UPDATE', data)
            if (data.id === context.state.current.id) {
              context.commit('CURRENT', data)
            }
            if (context.rootState.Group.current.integrators.length > 0) {
              context.commit('Group/integrator_UPDATE', data, { root: true })
            }
          }
        }).catch(() => {
        })
    }
  },
  destroyed (context, opts) {
    // always try to remove from list
    context.commit('LIST_REMOVE', opts)
    if (opts === context.state.current.id) {
      context.commit('CURRENT', null)
    }
  },
  // ===========================List Edits===============================
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/integrator', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  update (context, opts) {
    return new Promise((resolve, reject) => {
      const updates = Object.assign({}, context.state.update)
      for (const key of Object.keys(updates)) {
        if ((updates[key] === null || updates[key] === context.state.current[key]) && key !== 'id') {
          delete updates[key]
        }
      }
      console.log(updates)
      axios
        .patch(`/api/integrator/${context.state.current.id}`, updates)
        .then(({ data }) => {
          console.log(data)
          context.dispatch('detail', data.user)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  detail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/integrator/${id}`)
        .then(({ data }) => {
          context.commit('CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
